import { render, staticRenderFns } from "./courseData.vue?vue&type=template&id=e8ada72a&scoped=true&"
import script from "./courseData.vue?vue&type=script&lang=js&"
export * from "./courseData.vue?vue&type=script&lang=js&"
import style0 from "./courseData.vue?vue&type=style&index=0&id=e8ada72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ada72a",
  null
  
)

export default component.exports